import instituteSelector from 'modules/Auth/selectors'
import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'

export const SET_STUDENTS_DRIVE_LIST = 'institute_SET_STUDENT_DRIVE_LIST'
export const SET_VIEW_DRIVE_INFO = 'institute_SET_VIEW_DRIVE_INFO'

export const setStudentsDriveList = data => {
  return {
    type: SET_STUDENTS_DRIVE_LIST,
    data,
  }
}
export const setViewDriveInfo = data => {
  return {
    type: SET_VIEW_DRIVE_INFO,
    data,
  }
}

export const getStudentDriveListData =
  (id, setLoading, roleId, query = 'pageLimit=10&pageNo=0') =>
  async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id

    if (setLoading) {
      setLoading(true)
    }
    try {
      const data = await studentRequest.get(
        `/students/drive/${id}/candidate/list?collegeId=${instituteCampusId}`,
        {}
      )
      dispatch(setStudentsDriveList(data?.data?.data || []))
      if (setLoading) setLoading(false)
    } catch (error) {
      if (setLoading) setLoading(false)
    }
  }

export const getViewDriveInfo =
  (id, setLoading) => async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id

    try {
      let res = await corporateRequest.get(
        `/corporates/drive/${id}/institute/${instituteCampusId}`
      )
      dispatch(setViewDriveInfo(res?.data?.data))
    } catch (error) {
      setLoading(false)
    }
  }
